import { FC } from 'react'
import {
  DefaultFormContainer,
  FormItemTitle,
  AddressContentContainer,
  AddressOptions,
  FormInputErrorMessage
} from './styles'
import OptionButton from '../../basic/OptionButton'
import ReminderCard from '../../basic/ReminderCard'
import { ValidationErrorMessage } from 'src/components/basic/ValidationErrorMessage/ValidationErrorMessage';

interface OptionReminderProps {
  title: string;
  reminderTitle: string;
  reminderText: string;
  showOptions?: boolean;
  selectedOption?: boolean;
  setSelectedOption?: (option: boolean) => void;
  isIncorrect?: boolean;
  errorText?: string;
  errorCode?: string;
}

const OptionReminder: FC<OptionReminderProps> = ({
  title,
  reminderTitle,
  reminderText,
  showOptions,
  selectedOption,
  setSelectedOption,
  isIncorrect,
  errorText,
  errorCode = '',
}) => {
  const handleOptionButton = (option: boolean) => {
    if (!!setSelectedOption) {
      setSelectedOption(option)
    }
  }

  return (
    <DefaultFormContainer>
      <FormItemTitle>{title}</FormItemTitle>
      {showOptions ? (
        <>
          <AddressOptions>
            <OptionButton
              checked={selectedOption === true}
              onChange={() => handleOptionButton(true)}
              isIncorrect={(isIncorrect && (selectedOption === undefined || selectedOption === null))}
              errorCode={errorCode}
            >
              Yes
            </OptionButton>
            <OptionButton
              checked={selectedOption === false}
              onChange={() => handleOptionButton(false)}
              isIncorrect={(isIncorrect && (selectedOption === undefined || selectedOption === null))}
              errorCode={errorCode}
            >
              No
            </OptionButton>
          </AddressOptions>
          <ValidationErrorMessage errorCode={errorCode} />
          {isIncorrect && (selectedOption === undefined || selectedOption === null) ? (
            <FormInputErrorMessage>
              This is a required field
            </FormInputErrorMessage>
          ) : null}
          {isIncorrect && errorText ? (
            <FormInputErrorMessage>
              {errorText}
            </FormInputErrorMessage>
          ) : null}
        </>
      ) : null}
      {(!showOptions || (showOptions === true && selectedOption === true && !isIncorrect && !errorText)) ? (
        <AddressContentContainer style={{ maxWidth: '460px' }}>
          <ReminderCard
            icon='bulb'
            withLeftBar
            title={reminderTitle}
          >
            {reminderText}
          </ReminderCard>
        </AddressContentContainer>
      ) : null}
    </DefaultFormContainer>
  )
}

export default OptionReminder